const cities = [
  { name: "Douglasville", zips: "30134" },
  { name: "Villa Rica", zips: "30180" },
  { name: "Lithia Springs", zips: "30122" },
  { name: "Hiram", zips: "30141" },
  { name: "Austell", zips: "30106" },
  { name: "Powder Springs", zips: "30127" },
  { name: "Winston", zips: "30187" },
  { name: "Fairburn", zips: "30213" },
];

const benefits = [
  {
    icon: "ri-computer-line",
    title: "Start 100% Online",
    desc: "No office visit required to begin. Complete your expedited passport order from home or work in Douglasville in minutes.",
  },
  {
    icon: "ri-truck-line",
    title: "Ship Your Documents",
    desc: "Use overnight shipping to send your documents directly to us — we handle the emergency passport submission.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Expert Document Review",
    desc: "Every expedited passport application is reviewed by our team before submission to reduce errors and delays.",
  },
  {
    icon: "ri-calendar-check-line",
    title: "Reserved Agency Access",
    desc: "We hold reserved submission slots at the regional passport agency — no public appointment needed for your emergency passport.",
  },
];

export default function DouglasvilleLocalAreaSection() {
  return (
    <section id="service-area" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Expedited Passport Services for Douglasville &amp; West Metro Atlanta
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Whether you are in Douglasville, Villa Rica, Lithia Springs, Hiram, or anywhere in Douglas, Carroll, or Cobb counties, Fast Passport Center makes emergency and expedited passport processing simple — no agency lines, no guessing.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Left — FPC Info + How It Works */}
          <div>
            {/* FPC Info Card */}
            <div className="bg-[#1A365D] rounded-lg p-7 mb-8 text-white">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
                  <i className="ri-passport-line text-[#1A365D] text-xl"></i>
                </div>
                <div>
                  <p className="font-bold text-base">Fast Passport Center — Serving Douglasville &amp; West Metro Atlanta</p>
                  <p className="text-white/60 text-xs mt-0.5">Remote expedited passport services for Douglas, Carroll, and Cobb counties</p>
                </div>
              </div>
              <p className="text-white/70 text-sm mb-1">
                <i className="ri-map-pin-line text-[#F6C344] mr-1.5"></i>
                Serving all of Douglas, Carroll, and Cobb counties
              </p>
              <p className="text-white/50 text-xs mb-5 ml-5">Courier pickup available throughout west metro Atlanta</p>
              <div className="border-t border-white/10 pt-5">
                <p className="text-white/80 text-sm leading-relaxed mb-4">
                  After signing up online, choose what works best for you: <strong className="text-white">courier pickup</strong> from your home or office in most cases, <strong className="text-white">ship with our prepaid label</strong> from any UPS/FedEx location in Douglasville or nearby, or <strong className="text-white">schedule a drop-off</strong>. Most clients ship overnight — no visit required.
                </p>
                <a
                  href="https://fastpassportcenter.com/checkout/"
                  className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap"
                >
                  Start My Expedited Passport <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>

            {/* How FPC Helps */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {benefits.map((b, i) => (
                <div key={i} className="bg-[#F7F8FA] rounded-lg p-5 border border-gray-200">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#F6C344]/15 mb-3">
                    <i className={`${b.icon} text-[#1A365D] text-base`}></i>
                  </div>
                  <p className="font-bold text-[#1A365D] text-sm mb-1">{b.title}</p>
                  <p className="text-gray-500 text-xs leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Right — Cities We Serve + Trust strip */}
          <div>
            <div className="bg-[#F7F8FA] rounded-lg p-7 mb-6 border border-gray-200">
              <h3 className="font-bold text-[#1A365D] text-sm uppercase tracking-wide mb-5">
                <i className="ri-map-pin-2-line text-[#F6C344] mr-2"></i>
                Cities &amp; Communities We Serve Near Douglasville
              </h3>
              <div className="space-y-1.5">
                {cities.map((city, i) => (
                  <div
                    key={i}
                    className="flex items-center justify-between py-2.5 px-3 bg-white rounded-md"
                  >
                    <div className="flex items-center gap-2.5">
                      <i className="ri-checkbox-circle-fill text-[#F6C344] text-sm"></i>
                      <span className="text-[#1A365D] font-medium text-sm">{city.name}</span>
                    </div>
                    {city.zips && (
                      <span className="text-gray-400 text-xs font-mono">{city.zips}</span>
                    )}
                  </div>
                ))}
              </div>
              <p className="text-gray-500 text-xs mt-4 leading-relaxed">
                Anywhere in west metro Atlanta — start online, ship overnight from Douglasville, and we handle the rest. No need to drive to the Atlanta Passport Agency.
              </p>
              <div className="mt-4 pt-4 border-t border-gray-100">
                <p className="text-gray-400 text-xs font-semibold uppercase tracking-wider mb-3">Nearby Cities With Expedited Passport Service</p>
                <div className="flex flex-wrap gap-2">
                  {[
                    { name: "Atlanta", href: "/atlanta" },
                    { name: "Athens", href: "/athens" },
                    { name: "Marietta", href: "/marietta" },
                    { name: "Macon", href: "/macon" },
                    { name: "Savannah", href: "/savannah" },
                    { name: "Augusta", href: "/augusta" },
                    { name: "Columbus", href: "/columbus" },
                    { name: "Gainesville", href: "/gainesville-ga" },
                    { name: "Carrollton", href: "/carrollton" },
                    { name: "Duluth", href: "/duluth" },
                    { name: "Dalton", href: "/dalton" },
                  ].map((link) => (
                    <a
                      key={link.href}
                      href={link.href}
                      className="inline-flex items-center gap-1 text-xs text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors bg-white border border-gray-200 hover:border-[#F6C344] rounded-full px-3 py-1.5 whitespace-nowrap"
                    >
                      {link.name} <i className="ri-arrow-right-line text-[10px]"></i>
                    </a>
                  ))}
                </div>
              </div>
            </div>

            {/* Trust credentials strip */}
            <div className="bg-[#1A365D] rounded-lg p-5">
              <p className="text-white/50 text-xs uppercase tracking-widest font-semibold mb-4">Why Travelers Choose Fast Passport Center</p>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { icon: "ri-government-line", value: "Registered Courier", label: "U.S. Department of State" },
                  { icon: "ri-award-line", value: "A+ Rating", label: "Better Business Bureau" },
                  { icon: "ri-calendar-check-line", value: "20+ Years", label: "Serving Travelers Nationwide" },
                  { icon: "ri-customer-service-2-line", value: "Real Humans", label: "Live Support — Not a Bot" },
                ].map((item, i) => (
                  <a
                    key={i}
                    href="https://fastpassportcenter.com"
                    className="flex items-center gap-2.5 bg-white/5 hover:bg-white/10 rounded-md px-3 py-2.5 transition-colors cursor-pointer"
                  >
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0">
                      <i className={`${item.icon} text-sm text-[#F6C344]`}></i>
                    </div>
                    <div className="text-left">
                      <span className="text-white text-xs font-bold block leading-tight">{item.value}</span>
                      <span className="text-white/50 text-xs leading-tight block">{item.label}</span>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}